<button *ngIf="canAccessAlerts"
        #originRef
        (click)="showPopover()"
        [class.bg-hover]="dropdownOpen"
        [class.has-unread]="unreadCount > 0"
        class="button"
        mat-icon-button
        type="button"
        [matBadge]="unreadCount > 0 ? (unreadCount > 9 ? '9+' : unreadCount) : null"
        matBadgeColor="warn"
        matBadgeSize="medium"
        matBadgePosition="above after"
        [matBadgeHidden]="unreadCount < 1">
  <mat-icon color="primary" svgIcon="mat:notifications_active"></mat-icon>
</button>
